import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { AuthService } from "../service/auth/auth.service";
import { Router } from "@angular/router";

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.css'
})
export class LogoutComponent implements OnInit, OnDestroy {
  private safetyTimeoutId: ReturnType<typeof setTimeout> | null = null;
  private redirected = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private ngZone: NgZone,
  ) {}

  ngOnInit(): void {
    // Safety: if logout never settles, force redirect after 6s
    this.safetyTimeoutId = setTimeout(() => {
      this.redirectToLogin();
    }, 6_000);

    this.authService.logoutUser()
      .then(() => this.redirectToLogin())
      .catch(() => this.redirectToLogin());
  }

  private redirectToLogin(): void {
    if (this.redirected) return;
    this.redirected = true;
    if (this.safetyTimeoutId != null) {
      clearTimeout(this.safetyTimeoutId);
      this.safetyTimeoutId = null;
    }
    this.ngZone.run(() => this.router.navigate(['/login']));
  }

  ngOnDestroy(): void {
    if (this.safetyTimeoutId != null) {
      clearTimeout(this.safetyTimeoutId);
      this.safetyTimeoutId = null;
    }
  }
}
